<script setup>
import { defineEmits, defineProps } from 'vue'

defineProps(['header', 'text'])
const emit = defineEmits(['close'])

const close = () => {
  emit('close')
}
</script>

<template>
  <div class="dialog-wrapper">
    <div class="dialog-overlay"></div>
    <div class="dialog-box">
      <div class="dialog-header">
        <div class="dialog-header-text">
          {{ header }}
        </div>
      </div>
      <div class="dialog-content">
        <div
          v-html="text"
          class="agreement-text"
        ></div>
      </div>
      <div class="dialog-buttons">
        <button type="button" class="button no-background no-margin" @click="close">
          OK
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.dialog-box {
  display: flex;
  flex-direction: column;
}

.dialog-content {
  flex: 1;

  min-height: 200px;
  overflow-y: auto;
}

.agreement-text {
  line-height: 1.4em;
}

@media screen and (max-width: 768px) {
  .dialog-box {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    width: auto;
    height: auto;

    margin: 0;
    border-radius: 0;

    font-size: 12pt;
  }

  .dialog-header {
    border-radius: 0;
  }

  .dialog-buttons {
    padding-bottom: 1.5em;
  }
}

@media screen and (min-width: 769px) {
  .dialog-box {
    width: 60em;
    max-height: 95vh;
  }
}
</style>
